export enum ASSET_TYPE {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
}

export enum ASSET_CATEGORY {
  LOCATION = 'LOCATION',
  STATION = 'STATION',
  OTHER = 'OTHER',
}
